<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<h2>Tag Revenue Report</h2>

<div class="filter-bar">
  <div class="filter-field">
    <label>Check-In From</label>
    <p-calendar [(ngModel)]="startDate" dateFormat="mm/dd/yy" [showIcon]="true"
      appendTo="body" placeholder="Check-In From"></p-calendar>
  </div>
  <div class="filter-field">
    <label>Check-In To</label>
    <p-calendar [(ngModel)]="endDate" dateFormat="mm/dd/yy" [showIcon]="true"
      appendTo="body" placeholder="Check-In To"></p-calendar>
  </div>
  <div class="filter-field">
    <label>Check-Out Before</label>
    <p-calendar [(ngModel)]="checkOutDate" dateFormat="mm/dd/yy" [showIcon]="true"
      appendTo="body" placeholder="Check-Out Before"></p-calendar>
  </div>
  <div class="filter-field">
    <label>Sale Date From</label>
    <p-calendar [(ngModel)]="saleDateStart" dateFormat="mm/dd/yy" [showIcon]="true"
      appendTo="body" placeholder="Sale Date From"></p-calendar>
  </div>
  <div class="filter-field">
    <label>Sale Date To</label>
    <p-calendar [(ngModel)]="saleDateEnd" dateFormat="mm/dd/yy" [showIcon]="true"
      appendTo="body" placeholder="Sale Date To"></p-calendar>
  </div>
  <div class="filter-field">
    <label>Tags</label>
    <p-multiSelect [options]="allTags" [(ngModel)]="selectedTagIds"
      optionLabel="name" optionValue="tagId"
      defaultLabel="All Tags" display="chip" [showToggleAll]="true"
      [filter]="true" [scrollHeight]="'50vh'"
      [style]="{'minWidth':'220px'}" appendTo="body">
    </p-multiSelect>
  </div>
  <div class="filter-field">
    <label>Order Products</label>
    <p-multiSelect [options]="allOrderProducts" [(ngModel)]="selectedOrderProductIds"
      optionLabel="name" optionValue="orderProductId"
      defaultLabel="All Products" display="chip" [showToggleAll]="true"
      [filter]="true" [scrollHeight]="'50vh'"
      [style]="{'minWidth':'220px'}" appendTo="body">
    </p-multiSelect>
  </div>
  <div class="filter-field">
    <label>Res Type</label>
    <p-multiSelect [options]="reservationStatusOptions" [(ngModel)]="selectedReservationStatuses"
      optionLabel="label" optionValue="value"
      defaultLabel="All Statuses" display="chip" [showToggleAll]="true"
      [filter]="true" [scrollHeight]="'50vh'"
      [style]="{'minWidth':'220px'}" appendTo="body">
    </p-multiSelect>
  </div>
  <div class="filter-actions">
    <button pButton type="button" label="Search" icon="pi pi-search"
      (click)="onSearchSubmit()" [disabled]="loading"></button>
    <button pButton type="button" label="Reset" class="p-button-text"
      (click)="resetFilters()" [disabled]="loading"></button>
  </div>
</div>

<p-table #pt [value]="rows" selectionMode="single"
  [loading]="loading" [paginator]="true" [rows]="25"
  [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  sortMode="multiple" styleClass="p-datatable-striped"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left; margin: 6px;">Tagged Reservations</h1>
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
    </tr>
    <tr>
      @for (col of columns; track col) {
        <th [ngStyle]="{'width': 'auto'}">
          <input pInputText type="text" [ngStyle]="{'width':'50px','min-width':'100%'}"
            (input)="pt.filter($event.target.value, col.field, 'contains')" style="width: 100%">
        </th>
      }
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-res>
    <tr>
      <td> {{ res.tagsCsv }} </td>
      <td> {{ res.saleDate | date:'MM-dd-yyyy' }} </td>
      <td> {{ res.checkInDate | date:'MM-dd-yyyy' }} </td>
      <td> {{ res.checkOutDate | date:'MM-dd-yyyy' }} </td>
      <td>
        <a [href]="'/order/' + res.orderId" target="_blank"
          style="color:#4338ca; text-decoration:underline;">
          {{ res.reservationId }}
        </a>
      </td>
      <td> {{ res.orderId }} </td>
      <td> {{ res.guestLastName }} </td>
      <td> {{ resolveResStatusLabel(res.reservationStatus) }} </td>
      <td> {{ res.upsellRevenue | currency : 'USD' : 'symbol' : '1.2-2' }} </td>
      <td> {{ res.totalReservationRevenue | currency : 'USD' : 'symbol' : '1.2-2' }} </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="columns.length" style="text-align:center; padding: 1.5rem;">
        No reservations match your filters.
      </td>
    </tr>
  </ng-template>
</p-table>
